import {TRANSLATION, Yup} from '@/imports-files/components/add-to-job-modal';

export const ADD_TO_JOB_INITIAL_VALUES =  {
                                            select_job: ''
                                        }


export const ADD_TO_JOB_MODAL_SCHEMA =   Yup.object({
                                                         select_job: Yup.string().required(TRANSLATION('common:errors:required'))
                                                     })


export const UNSUCCESSFUL_REASON_INITIAL_VALUES =  {
                                            reason_id: '',
                                            reason_text: '',
                                            reason: ''
                                        }


export const UNSUCCESSFUL_REASON_MODAL_SCHEMA =   Yup.object({
                                                        reason: Yup.string(),
                                                        reason_id: Yup.string().required(TRANSLATION('common:errors:required')),
                                                        reason_text: Yup.string().when("reason", {
                                                          is: (reason) => { return reason == "Other" },
                                                          then: Yup.string().required(TRANSLATION('common:errors:required')).max(50, 'Reason is too long (maximum is 50 characters)')
                                                        }).test("other", "Invalid reason", function(value) {
                                                          return value?.trim()?.toLowerCase() != "other"
                                                        })
                                                     })



